const stringsEN = {
  'general.loggingIn': 'Logging you in...',
  'general.invalidPassword': 'Password is invalid, try again',
  'general.goToLogin': 'Go to login',
  'general.loggedOutText': 'You have been logged out',
  'general.changePassword': 'Change password',
  'general.modified': 'Modified',
  'general.mobile': 'Mobile',
  'general.desktop': 'Desktop',
  'general.backTo': 'Back to',
  'general.synced': 'Syncronized',
  'general.assigned': 'assigned',
  'general.notAssigned': 'not assigned',
  'menuLabel.notesAndDocuments': 'Notes and documents',
  'plants.filterByTag': 'Filter by tag',
  'plants.recentlyModified': 'sort by recently modified',
  'plants.plantName': 'sort by plant name',
  'newPlantDialog.insertGroup': '+ add a new group and press Enter',
  'plantDetail.addDevice': 'Add device',
  'plantDetail.addObjects': 'Add objects',
  'plants.noPlantsHint':
    'Click on the "New plant" button to create a new plant',
  'plantDetail.newUpdates': 'New updates',
  'plantDetail.willRefreshToReflectChanges':
    'This element has been updated. The page will refresh to reflect the changes.',
  'plantDetail.addGroup': 'Add group',
  'plantDetail.addScene': 'Add scene',
  'plantC300EOSSettings.GeneralSettings': 'General Settings',
  'plantC300EOSSettings.DoorEntryParametrs': 'DOOR ENTRY PARAMETERS',
  'plantC300EOSSettings.descPage':
    'Not all parameters are editable from this section: you will have to do it on site with the connected app',
  'general.favourites': 'Favourites',
  'general.select': 'Select',
  'general.operationError': 'Operation error',
  'plantDetail.lastScan': 'Last scan: {date} at {time}',
  'general.assignIcon': 'Assign the icon',
  'general.assignedIcon': 'Assigned icon',
  'newPlantDialog.modified': 'Plant modified',
  'plantDetail.deletePlantConfirm':
    'Are you sure you want to delete {plantName}? All data will be lost. To delete insert the code {code} and confirm',
  'plantDetail.objectsCreated': 'Objects successfully created',
  'plantDetail.selectDevice': 'Select a device to view its modules',
  'plantDetail.typeNameGroup': 'Type and name of group',
  'plantDetail.disableScene': 'Disable scene',
  'plantDetail.disableSceneConfirm':
    'Are you sure you want to disable scene "{sceneName}"?',
  'plantC300EOSSettings.SetAsPrimaryEntryUnitDESC':
    'The primary door entry unit is the only one which transfers the call from the app and manages the answering machine',
  'plantC300EOSSettings.ProfessionalStudioDESC':
    'When enabled by user, professional studio auto opens door lock each time someone rings',
  'scenes.trigger': 'trigger',
  'uniqueNaming.validationError': 'Name is invalid',
  'uniqueNaming.unavailableName': 'Unavailable name',
  'uniqueNaming.roomInlineNamingError': 'Could not update the name',
  'uniqueNaming.roomInlineNamingSuccess': 'Room name updated',
  'uniqueNaming.nameResetDisclaimer':
    'The name will be reset to the initial one',
  'uniqueNaming.validationErrorWithSuggestion':
    'Name is invalid, you can try with: "{suggestedName}"',
  'plantsList.duplicateDialog.inputLabel': 'You can adjust plants names here',
  'plantDialogDuplicate.howManyCopies': 'How many copies',
  'plantDialogDuplicate.success': 'Plant duplicated',
  'general.actuatorAdded': 'Actuator added',
  'general.commandAdded': 'Command added',
  'entrancePlant.addGate': 'Add gate',
  'entrancePlant.addDevice': 'Add device',
  'entrancePlant.noSwitchboard': 'No switchboard',
  'entrancePlant.hintNewSwitchboard':
    'Click on Add Switchboard to create a new one',
  'entrancePlant.deleteSwitchboard': 'Delete switchboard',
  'entrancePlant.deleteSwitchboardQuestion':
    'Are you sure to delete the switchboard?',
  'entrancePlant.editedSwitchboard': 'Switchboard edited',
  'entrancePlant.gates.detail.noDevices': 'NO DEVICES',
  'entrancePlant.NoBadges': 'No badges',
  'entrancePlant.hintNewBadge': 'Click on Add Badge to create a new one',
  'entrancePlant.BadgeAddCodeManuallyOrScan': 'Type the code or scan it ',
  'entrancePlant.BadgeAddedList': 'Added badges',
  'entrancePlant.BadgeAddedListEmpty': 'No badges added yet',
  'general.alreadyExisting': 'Already existing',
  'entrancePlant.addGuest': 'New guest',
  'entrancePlant.noGuests': 'No guests',
  'entrancePlant.hintNewGuest': 'Click on NEW GUEST to create a new one',
  'entrancePlant.permissionsData': 'Data',
  'entrancePlant.permissionsTimeRanges': 'Time ranges',
  'entrancePlant.associatedBadges': 'Associated badges',
  'entrancePlant.gateGuestBannerCreated': 'Guest created',
  'entrancePlant.gateGuestBannerUpdated': 'Guest edited',
  'entrancePlant.codeLenghtOrNotNumbers':
    'Code should be a {keypadCodeLength} digit number',
  'entrancePlant.newBuilding': 'New building',
  'entrancePlant.editedBuilding': 'Building edited',
  'entrancePlant.buildingBannerCreated': 'Building added',
  'entrancePlant.editedApartment': 'Apartment edited',
  entrancePlant: {
    noUserInvitedYet: 'No user invited yet',
    apartmentsBannerCreated: 'Apartments created',
    noInformationsAdded: 'No informations added',
  },

  isEditingPlant: 'is editing the configuration',
  eliotParseException: 'Problem reading the plant configuration from cloud.',

  assignObject: {
    selectFromLastScan: 'Select from last scan',
    selectFromCatalogue: 'Select from catalogue',
  },
  assignThermo: {
    selectOnlyOneDescription:
      'TEMP STRING You should select one and only one device.',
    thermostatAdded: 'Thermostat added',
    heatingActuatorAdded: 'Heating actuator added',
    coolingActuatorAdded: 'Cooling actuator added',
    sharedActuatorAdded: 'Shared actuator added',
    heatingPumpAdded: 'Heating pump added',
    coolingPumpAdded: 'Cooling pump added',
    sharedPumpAdded: 'Shared pump added',
    probeAdded: 'Probe added',
  },
  'alarm.alarmsensor': 'Alarm sensor',
  saveAndContinue: 'Save and continue',
  SetupRisersTitle:
    'Set up the risers, floors and apartments of {buildingName}',
  SelectDevicesInGate: 'Select the devices present in the gate',
  TheyManage: 'They manage',
  BuildingNameOnly: '{buildingName} only',
  SaveChanges: 'Save changes',
};

export default stringsEN;
